<template>
  <component :is="current" v-bind="$attrs" />
</template>

<script setup>
import { useUiWrapper } from "@/utils/uiWrapper";
import FooterViewOld from "./Old/OldCanvasView.vue";
import NewFooterView from "./New/NewCanvasView.vue";

const current = useUiWrapper(FooterViewOld, NewFooterView);
</script>
